import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconService, IconDirective } from '@ant-design/icons-angular';
import { CloseOutline, UserOutline, TeamOutline, ToolOutline, CrownOutline } from '@ant-design/icons-angular/icons';
import { RoleService, Role } from '../../Services/role.service';

@Component({
  standalone: true,
  selector: 'app-role-selector',
  imports: [CommonModule, IconDirective],
  templateUrl: './role-selector.component.html',
  styleUrls: ['./role-selector.component.scss']
})
export class RoleSelectorComponent {
  private iconService = inject(IconService);
  private roleService = inject(RoleService);
  
  isOpen = input<boolean>(false);
  closePopup = output();
  roleSelected = output<Role>();

  roles: Role[] = [];

  constructor() {
    this.iconService.addIcon(...[CloseOutline, UserOutline, TeamOutline, ToolOutline, CrownOutline]);
    this.loadRoles();
  }

  loadRoles() {
    this.roleService.getRoles().subscribe(roles => {
      this.roles = roles;
    });
  }

  onRoleSelect(role: Role) {
    this.roleService.setCurrentRole(role);
    this.roleSelected.emit(role);
    this.closePopup.emit();
  }

  onClose() {
    this.closePopup.emit();
  }

  getRoleIcon(roleName: string): string {
    switch(roleName) {
      case 'admin': return 'crown';
      case 'labour': return 'user';
      case 'owner': return 'team';
      case 'constructor': return 'tool';
      default: return 'user';
    }
  }
}